
import { NgModule } from '@angular/core';
 
import { ProviderBioPage } from './provider-bio.component';
import { ProviderBioDetailPage} from './provider-bio-detail.component';
import { CommonModule } from "@angular/common";

  
@NgModule({
    imports: [
        CommonModule
    ]
    ,
    declarations: [
        ProviderBioPage,
        ProviderBioDetailPage
    ],
    exports: [
        ProviderBioPage,
        ProviderBioDetailPage
    ]
})
export class ProviderModule {

}
